import React, {useContext, useEffect} from "react";
import {UIStoreContext} from "../../context";
import {observer} from "mobx-react-lite";
import {useNavigate} from "react-router-dom";

import styles from "./DeviceItem.module.scss";
import {DateTime} from "luxon";
import green_v from "./icons/green.svg";
import green_r from "./icons/green_r.svg";
import red_r from "./icons/red_r.svg";
import {SystemType} from "../../common/systemType";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import deviceManagementService from "../../client-api/services/deviceManagement";
import {Box, Tooltip} from "@mui/material";
import {UserRole} from "../../common/userRole";


export interface DeviceItemInterface {
    device_name: Object;
    id: string;
    last_active: number;
    status: string;
    connection_state: any;
}


const DeviceItem = ({item, onPingStatusChange, pingStatus}: any) => {
    const uiStore = useContext(UIStoreContext);
    const navigate = useNavigate()

    // Call ping for this device
    const pingResponse = deviceManagementService.ping(item.id);

    function parseDate(dateValue: any,) {
        return dateValue != "" ? DateTime.fromMillis(dateValue * 1000).toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS) : "--";
    }

    const gotoEventsReport2 = (id: string) => {
        uiStore.setMapDrawerOpen(false);
        uiStore.setSelectedSystem(id);
        uiStore.setCurrentPage("Events");
        navigate("../performanceReport");
    };

    // Use ping status from parent if available, then from response, then fall back to connection_state
    const isOnline = pingStatus !== undefined
        ? pingStatus
        : (pingResponse?.isSuccess && pingResponse?.data?.status !== undefined
            ? pingResponse.data.status === 200
            : (item.connection_state === 'Connected'));

    const lastActive = pingResponse?.isSuccess && pingResponse?.data?.last_active !== "" ? pingResponse?.data.last_active : "";

    const gotoEventsReport = (id: string, device_type: number, org: string, version: string) => {
        uiStore.setSelectedSystem(id);

        if (uiStore.getUsersInfo().org_id === 1) {
            uiStore.setUpdatesDrawerData({
                system_id: id,
                device_type: device_type,
                device_org: org,
                loco_name: item.loco_name,
                isOnline: isOnline,
                last_active: lastActive,
                current_version: version,
            });
            uiStore.setUpdatesDrawerOpen(true);

        } else {
            uiStore.setMapDrawerOpen(false);

            uiStore.setCurrentPage("Events");
            navigate("../performanceReport");
        }
    };

    const getUpdateStatusText = (update_status: any) => {
        let updateTitle = "Ready";
        switch (update_status) {
            case 10:
                updateTitle = "Downloading Update"
                break;
            case 20:
                updateTitle = "Download Completed"
                break;
            case 30:
                updateTitle = "Installation Completed"
                break;
            case 40:
                updateTitle = "Installation Failed"
                break;

        }

        return updateTitle;
    }

    // Report ping status to parent component
    useEffect(() => {
        if (pingResponse?.isSuccess && pingResponse?.data?.status !== undefined && onPingStatusChange) {
            onPingStatusChange(item.id, pingResponse.data.status === 200);
        }
    }, [pingResponse?.isSuccess, pingResponse?.data?.status, item.id, onPingStatusChange]);

    return (
        <div className={`${styles.deviceItem}`}
             onClick={() => gotoEventsReport(item.id, item.device_type, item.org, item.version)}>
            <div className={`${styles.deviceItemTitleContainer}`}>
                <img
                    src={isOnline ? green_r : red_r}
                    alt={"Connection State"}
                />
                <div className={`${styles.deviceNameTitle}`}>{(item.loco_name).toUpperCase()}
                </div>

            </div>

            <div
                className={(item.device_type === SystemType.SwitchYard.valueOf()) ? `${styles.deviceItemImageSY}` : `${styles.deviceItemImageML}`}>

            </div>
            <div className={`${styles.deviceInfoContainer}`}>
                {/* <div className={`${styles.deviceInfoTop}${}`}>*/}
                <div className={`${styles[`deviceInfoTop${pingResponse?.data?.update_status?.status ?? ""}`] || ""}`}>
                    <div
                        className={`${styles.deviceItemInfoText}`}>
                        {getUpdateStatusText(pingResponse?.data?.update_status?.status)}
                    </div>
                    <div className={`${styles.deviceItemInfoText}`}>

                        <Tooltip
                            //                         title={"Current: " + item.version + '\n' + "Requested: " + pingResponse?.data?.update_status?.version}
                            title={
                                <span style={{whiteSpace: 'pre-line'}}>
                                  {"Current: " + item.version}
                                    <br/>
                                    {"Requested: " + pingResponse?.data?.update_status?.version}
                                </span>
                            }

                            arrow
                            placement="top-end" // tooltip above anchor → arrow points down on the right
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        bgcolor: "#FFFFFF",
                                        color: "#000000",
                                        border: "1px solid #D1D1D1",
                                        borderRadius: "2px",
                                        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.12)",
                                        fontSize: "14px",
                                        fontWeight: 400,
                                        fontFamily: "Everett Regular",
                                        lineHeight: 1.4,
                                        maxWidth: 330,
                                        px: 1.5, // ~12px
                                        py: 1.25, // ~10px
                                        "& .MuiTooltip-arrow": {
                                            color: "#FFFFFF",
                                            "&::before": {
                                                border: "1px solid #D1D1D1",
                                            },
                                        },
                                    },
                                },
                            }}
                        >
                            <Box display="inline-block">
                                <InfoOutlinedIcon fontSize={'small'} className={styles.infoIcon}/>
                            </Box>
                        </Tooltip>


                    </div>
                </div>
                <div className={`${styles.deviceInfoBottom}`}>
                    <div
                        className={`${styles.deviceItemInfoTextBottom}`}>Last
                        seen
                    </div>
                    <div
                        className={`${styles.deviceItemInfoTextBottom}`}>{parseDate(lastActive)}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default observer(DeviceItem)